<template>
	<div class="m-product-list flex-between">
		<ul>
			<template v-for="(item, i) in unitData.product_list">
				<li v-if="i % 2 == 0" :key="item.product_id">
					<sub-image class="image" :src="item.product_img_url" mode="widthFix"></sub-image>
					<div class="info">
						<p class="name ellipsis-2">{{item.product_name}}</p>
						<div class="price">￥{{item.sale_price}}</div>
					</div>
				</li>
			</template>
		</ul>
		<ul>
			<template v-for="(item, i) in unitData.product_list">
				<li v-if="i % 2 == 1" :key="item.product_id">
					<sub-image class="image" :src="item.product_img_url" mode="widthFix"></sub-image>
					<div class="info">
						<p class="name ellipsis-2">{{item.product_name}}</p>
						<div class="price">￥{{item.sale_price}}</div>
					</div>
				</li>
			</template>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-list {
		padding: 10px 12px;
		
		ul {
			li {
				width: 169px;
				border-radius: 4px;
				overflow: hidden;
				background: #fff;
				
				&:nth-child(n+2) {
					margin-top: 13px;
				}
				
				.info {
					padding: 5px 11px 0;
					
					.name {
						line-height: 18px;
						font-size: 12px;
						color: #333;
					}
					
					.price {
						line-height: 35px;
						font-size: 15px;
						font-weight: bold;
					}
				}
			}
		}
	}
</style>
